export const isMobile = () => {
  const href = globalThis.location?.href;
  if (!href) {
    return false;
  }
  const searchParams = new URL(href).searchParams;
  return searchParams.has('mobile') && Boolean(searchParams.get('mobile'));
};

export const isMobileMode = isMobile();
